import React from 'react';
import Map from '../components/Map';
import earthquake from '../asset/images/earthquake.png';

class MapContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      input: '',
      data: [],
    }
    this.findHighpoint = this.findHighpoint.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    fetch('https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_day.geojson')
    .then((response) => {
      return response.json();
    })
    .then((body) => {
      this.setState({
        ...this.state,
        isFetching: false,
        data: body,
      });
    })
    .catch((err) => {
      console.log('error');
    })
  }

  makeLatLngRequest(value) {
      var _this = this;
      googleMapsLatLng(value);
      function googleMapsLatLng(postcode) {
        let googleMapURL = `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode.replace(" ","+")}&key=AIzaSyAmSmnSfBQtOax_Ig9QVNBsDHBJB3VU7Ds`;
        fetch(googleMapURL)
          .then(response => {
            return response.json()
          })
          .then(body => {
            if(body.results.length > 0) {
              console.log(body.results);
              let latitude = body.results[0].geometry.location.lat;
              let longitude = body.results[0].geometry.location.lng;
              _this.setState({
                ..._this.state,
                userLocation: { lat: latitude, lng: longitude },
              })
            }
          })
          .catch(error => {
            console.log('error fegching results');
          });
      };
  }

  handleClick(e) {
    console.log(e.target.value);
    this.setState({
      ...this.state,
      input: e.target.value,
    })
  }

  handleSubmit(e) {
    if (e.key === 'Enter') {
      console.log('enter', this.state.input);
      this.makeLatLngRequest(this.state.input)
    }
  }

  findHighpoint() {
    let _this = this;
    var geoSuccess = function(position) {
      _this.setState({
        ..._this.state,
        userLocation: {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
      })
    };
    navigator.geolocation.getCurrentPosition(geoSuccess);
  }

  render() {
    if (this.state.isFetching) {
      return (<div>Loading</div>)
    }
    else {
      return (
      <div>
        <div className="alert alert-info" style={{paddingLeft: 60, paddingRight: 60 }}><p><strong>About tsunami reporter - just for fun, dont use!!!!</strong></p> earthquakes that have occured in past 24 hours above 4.5 magnitutde are marked on the map,
        earthquakes at sea above 7 may trigger tsunamis, to check for high points near your location enter your address or find your location via browser geolocation </div>
        <div style={{ margin: 20 }}>
        <p>Find high point &nbsp;&nbsp;&nbsp;
        <button className="btn btn-default" onClick={this.findHighpoint} >Near me</button></p>
        Search address &nbsp;&nbsp;<input className="form-control" value={this.state.input} style={{ height: 36, width: 150, display: 'inline' }} onChange={this.handleClick} onKeyPress={this.handleSubmit} />
        </div>
        <Map 
          data={this.state.data} 
          userLocation={this.state.userLocation}  
        />
      </div>
      );
    }
  }

}

export default MapContainer;


// WEBPACK FOOTER //
// ./src/containers/MapContainer.js